import(/* webpackMode: "eager" */ "/codebuild/output/src4135544797/src/bitbucket.org/grupoblidoo/passport-frontend/src/app/[lang]/error.tsx");
